import { render } from "./CardPack.vue?vue&type=template&id=382b956c"
import script from "./CardPack.vue?vue&type=script&lang=js"
export * from "./CardPack.vue?vue&type=script&lang=js"

import "./CardPack.vue?vue&type=style&index=0&id=382b956c&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__